if(!customElements.get('product-badge')) {
    class ProductBadge extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            this.init();
        }

        init(){
            let productLink = this.dataset.productLink;
            productLink = productLink.split('?');
            productLink = productLink[0];
            this.productLink = `${productLink}`;

            fetch(this.productLink)
            .then(res => {
                if(!res.ok){
                    var error = new Error(res.status);
                    const blockWrapper = this.closest('.product-badge-block');
                    if(blockWrapper)
                        blockWrapper.dataset.loaded = "false";
                    throw error;
                }

                return res.text();
            })
            .then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
                const productInfo = resultsMarkup.querySelector('product-info');

                if (productInfo) {
                    const badge = productInfo.querySelector('.product-badge-block');
                    if (badge) {
                        this.innerHTML = badge.innerHTML;
                        const blockWrapper = this.closest('.product-badge-block');
                        if(blockWrapper){
                            blockWrapper.dataset.loaded = "true";
                        }
                    }
                }
            });
        }
    }
    customElements.define('product-badge', ProductBadge);
}